import {declintRu} from '@specials/utils';

export class DeclineUtils {
  static declineCharge(charge: number): string {
    return declintRu(charge, ['заряд', 'заряда', 'зарядов']);
  }

  static declineDays(days: number): string {
    return declintRu(days, ['день', 'дня', 'дней']);
  }

  static declineTickets(tickets: number): string {
    return declintRu(tickets, ['билет', 'билета', 'билетов']);
  }
}
